import BaseModel from "../../../core/components/input-widget/BaseModel";
import i18n from "@/shared/i18n";

export default class ContinuousAuctionBatchLotUpBatchEditModel extends BaseModel {
  set_date_by_batch = null;
  start_date = null;
  end_date = null;
  start_time = null;
  end_time = null;

  attributeLabels = {
    start_date: i18n.t("Start Date"),
    end_date: i18n.t("End Time"),
    start_time: i18n.t("Start Date"),
    end_time: i18n.t("End Time"),
    set_date_by_batch: i18n.t('Bulk Set Start and End Dates')
  }

  customMessages = {
  }

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }
}
